import React, { useState, createContext } from 'react'

export const GlobalErrorContext = createContext();

const GlobalErrorContextProvider = (props) => {
  const [isGlobalError, setGlobalError] = useState({
    isError: false,
    errorCode: ""
  });

  return (
    <GlobalErrorContext.Provider value={{isGlobalError, setGlobalError}}>
      {props.children}
    </GlobalErrorContext.Provider>
  )
}

export default GlobalErrorContextProvider;
